/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Analyze_Allocations_Overall_OccupancyInputs */

const en_admin_analyze_allocations_overall_occupancy = /** @type {(inputs: Admin_Analyze_Allocations_Overall_OccupancyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Occupancy`)
};

const de_admin_analyze_allocations_overall_occupancy = /** @type {(inputs: Admin_Analyze_Allocations_Overall_OccupancyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtauslastung`)
};

const es_admin_analyze_allocations_overall_occupancy = /** @type {(inputs: Admin_Analyze_Allocations_Overall_OccupancyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocupación general`)
};

const fr_admin_analyze_allocations_overall_occupancy = /** @type {(inputs: Admin_Analyze_Allocations_Overall_OccupancyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taux d'occupation global`)
};

/** @type {(inputs: Admin_Analyze_Allocations_Overall_OccupancyInputs) => LocalizedString} */
const it_admin_analyze_allocations_overall_occupancy = en_admin_analyze_allocations_overall_occupancy;

/** @type {(inputs: Admin_Analyze_Allocations_Overall_OccupancyInputs) => LocalizedString} */
const pt_br2_admin_analyze_allocations_overall_occupancy = en_admin_analyze_allocations_overall_occupancy;

/** @type {(inputs: Admin_Analyze_Allocations_Overall_OccupancyInputs) => LocalizedString} */
const pl_admin_analyze_allocations_overall_occupancy = en_admin_analyze_allocations_overall_occupancy;

/** @type {(inputs: Admin_Analyze_Allocations_Overall_OccupancyInputs) => LocalizedString} */
const hu_admin_analyze_allocations_overall_occupancy = en_admin_analyze_allocations_overall_occupancy;

/** @type {(inputs: Admin_Analyze_Allocations_Overall_OccupancyInputs) => LocalizedString} */
const ro_admin_analyze_allocations_overall_occupancy = en_admin_analyze_allocations_overall_occupancy;

/**
* | output |
* | --- |
* | "Overall Occupancy" |
*
* @param {Admin_Analyze_Allocations_Overall_OccupancyInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_analyze_allocations_overall_occupancy = /** @type {((inputs?: Admin_Analyze_Allocations_Overall_OccupancyInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Analyze_Allocations_Overall_OccupancyInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_analyze_allocations_overall_occupancy(inputs)
	if (locale === "de") return de_admin_analyze_allocations_overall_occupancy(inputs)
	if (locale === "es") return es_admin_analyze_allocations_overall_occupancy(inputs)
	if (locale === "fr") return fr_admin_analyze_allocations_overall_occupancy(inputs)
	if (locale === "it") return it_admin_analyze_allocations_overall_occupancy(inputs)
	if (locale === "pt-BR") return pt_br2_admin_analyze_allocations_overall_occupancy(inputs)
	if (locale === "pl") return pl_admin_analyze_allocations_overall_occupancy(inputs)
	if (locale === "hu") return hu_admin_analyze_allocations_overall_occupancy(inputs)
	return ro_admin_analyze_allocations_overall_occupancy(inputs)
});
export { admin_analyze_allocations_overall_occupancy as "admin.analyze.allocations.overall_occupancy" }